import React from "react";
import "./GanpatipulePackage.css";

const itinerary = [
  {
    day: "Day 1",
    title: "Pune to Ganpatipule",
    places: ["Pune", "Ganpatipule"],
    note: "Arrival at Ganpatipule",
  },
  {
    day: "Day 2",
    title: "Ganpatipule Sightseeing",
    places: ["Ganpatipule Temple", "Local Sightseeing"],
    note: "Ganpatipule local tour",
  },
  {
    day: "Day 3",
    title: "Ganpatipule to Pune",
    places: ["Ganpatipule", "Pune"],
    note: "Return journey to Pune",
  },
];

const vehicles = [
  {
    name: "Sedan Cab",
    price: "₹12,499",
    icon: "🚘",
  },
  {
    name: "Ertiga Cab",
    price: "₹15,199",
    icon: "🚙",
  },
  {
    name: "Kia Carens",
    price: "₹17,899",
    icon: "🚗",
  },
  {
    name: "Innova Crysta",
    price: "₹19,699",
    icon: "🚐",
    popular: true,
  },
];

export default function GanpatipulePackage() {
  return (
    <section className="gp-package">
      <div className="gp-container">

        {/* HEADER */}
        <div className="gp-header">
          <div className="gp-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="gp-logo"
            />
          </div>

          <div className="gp-header-content">
            <span className="gp-badge">
              3 DAYS TOUR PACKAGE
            </span>

            <h1>
              Pune to Ganpatipule
              <span> 3-Day Package</span>
            </h1>

            <p>
              Enjoy a comfortable Commercial Cab journey from Pune to
              Ganpatipule with a well-planned 3-day tour package by
              Garud Cabs.
            </p>
          </div>
        </div>

        {/* ROUTE */}
        <div className="gp-route">
          <span className="gp-route-label">
            TOUR ROUTE
          </span>

          <div className="gp-route-text">
            Pune <b>→</b> Ganpatipule
            <b> → </b> Local Sightseeing
            <b> → </b> Ganpatipule
            <b> → </b> Pune
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="gp-main-grid">

          {/* ITINERARY */}
          <div className="gp-card">

            <div className="gp-section-heading">
              <div className="gp-heading-number">
                03
              </div>

              <div>
                <small>COMPLETE TRAVEL PLAN</small>
                <h2>3-Day Ganpatipule Tour</h2>
              </div>
            </div>

            <div className="gp-timeline">

              {itinerary.map((item, index) => (
                <div
                  className="gp-timeline-item"
                  key={item.day}
                >
                  <div className="gp-day-number">
                    {index + 1}
                  </div>

                  <div className="gp-day-content">

                    <div className="gp-day-title">
                      <span>{item.day}</span>
                      <h3>{item.title}</h3>
                    </div>

                    <div className="gp-places">
                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>
                          <span>{place}</span>

                          {i !== item.places.length - 1 && (
                            <b>→</b>
                          )}
                        </React.Fragment>
                      ))}
                    </div>

                    <div className="gp-day-note">
                      🚖 {item.note}
                    </div>

                  </div>
                </div>
              ))}

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="gp-side">

            <div className="gp-card gp-details">
              <span className="gp-mini-label">
                TOUR DETAILS
              </span>

              <h2>Ganpatipule Package</h2>

              <div className="gp-detail-row">
                <span>Starting Point</span>
                <strong>Pune</strong>
              </div>

              <div className="gp-detail-row">
                <span>Destination</span>
                <strong>Ganpatipule</strong>
              </div>

              <div className="gp-detail-row">
                <span>Duration</span>
                <strong>3 Days</strong>
              </div>

              <div className="gp-detail-row">
                <span>Journey Type</span>
                <strong>Round Trip</strong>
              </div>

              <div className="gp-detail-row">
                <span>Vehicle</span>
                <strong>Commercial Cab</strong>
              </div>
            </div>

            {/* HIGHLIGHTS */}
            <div className="gp-card gp-highlights">

              <span className="gp-mini-label">
                PACKAGE HIGHLIGHTS
              </span>

              <div className="gp-highlight-grid">
                <div>
                  <span>✓</span>
                  Pune Pickup
                </div>

                <div>
                  <span>✓</span>
                  Commercial Cab
                </div>

                <div>
                  <span>✓</span>
                  3-Day Tour
                </div>

                <div>
                  <span>✓</span>
                  Ganpatipule Visit
                </div>

                <div>
                  <span>✓</span>
                  Local Sightseeing
                </div>

                <div>
                  <span>✓</span>
                  Pune Return
                </div>
              </div>

            </div>

            <div className="gp-note">
              <strong>🏖️ Ganpatipule Tour</strong>

              <p>
                A comfortable 3-day Commercial Cab package for families,
                couples and groups travelling from Pune to Ganpatipule.
              </p>
            </div>

          </div>
        </div>

        {/* PRICING */}
        <div className="gp-pricing">

          <div className="gp-pricing-heading">

            <div>
              <span className="gp-mini-label">
                CHOOSE YOUR CAB
              </span>

              <h2>Ganpatipule Package Price</h2>
            </div>

            <p>
              Pune → Ganpatipule → Pune
            </p>

          </div>

          <div className="gp-vehicle-grid">

            {vehicles.map((vehicle) => (
              <div
                className={`gp-vehicle-card ${
                  vehicle.popular ? "gp-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="gp-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="gp-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="gp-vehicle-info">
                  <h3>{vehicle.name}</h3>
                  <small>3-Day Package</small>
                </div>

                <div className="gp-price">
                  {vehicle.price}
                </div>

              </div>
            ))}

          </div>
        </div>

        {/* CTA */}
        <div className="gp-booking">

          <div>
            <span>GARUD CABS • PUNE</span>

            <h2>
              Book Your Ganpatipule Tour
            </h2>

            <p>
              3-Day Package • Commercial Cab • Comfortable Journey
            </p>
          </div>

          <a
            href="tel:+919970007784"
            className="gp-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}